import React, { useRef } from 'react';
import { StyleProp, TextStyle, View, ViewStyle, Image, TouchableOpacity } from 'react-native';
import { IconDefinition, faXmark } from '@fortawesome/free-solid-svg-icons';
import CustomButton, { ButtonTypes } from './CustomButton';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface FileUploadProps {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    accept?: string;
    text?: string;
    icon?: IconDefinition;
    type?: ButtonTypes;
    /**
     * button style
     */
    style?: StyleProp<ViewStyle>;
    /**
     * text style
     */
    textStyle?: TextStyle;
    /**
     * button style
    */
    contentContainerStyle?: StyleProp<ViewStyle>;
    /**
     * controlled preview url; when provided, shows the image preview
     */
    previewUrl?: string;
    /**
     * called when the user removes the selected file
     */
    onRemove?: () => void;
}

export default function FileUploader({ onChange, accept, text, icon, type, style, textStyle, contentContainerStyle, previewUrl, onRemove }: FileUploadProps) {
    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const { styles } = useStyles(stylesheet);

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const handleRemove = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        onRemove?.();
    };

    return (
        <>
            <input
                type='file'
                style={{ display: 'none' }}
                onChange={onChange}
                ref={(input) => (fileInputRef.current = input)}
                accept={accept}
            />
            <View style={styles.buttonContainer}>
                <CustomButton text={text} icon={icon} type={type} onPress={handleUploadClick} style={style} textStyle={textStyle} contentContainerStyle={contentContainerStyle} />
            </View>
            {previewUrl &&
                <View style={styles.previewContainer}>
                    <Image source={{ uri: previewUrl }} style={styles.previewImage} />
                    <TouchableOpacity style={styles.removeButton} onPress={handleRemove}>
                        <FontAwesomeIcon icon={faXmark} width={14} height={14} color='#fff' />
                    </TouchableOpacity>
                </View>
            }
        </>
    );
}

const stylesheet = createStyleSheet((theme) => ({
    buttonContainer: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
    },
    previewContainer: {
        marginTop: 8,
        alignSelf: 'flex-start',
    },
    previewImage: {
        width: 100,
        height: 100,
        borderRadius: 8,
    },
    removeButton: {
        position: 'absolute',
        top: -6,
        right: -6,
        backgroundColor: theme.colors.backgrounds['BG-1'],
        borderRadius: 12,
        width: 24,
        height: 24,
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
